/* globals jQuery, dataLayer, tmpl */
import { easing, animSpeed } from './_vars.js';
import ITNotification from './Notification.class.js';
import * as Ladda from 'ladda';

(function(document, $) {
	const NotificationInstance = new ITNotification();

	function handleRegistrationError(error) {
		NotificationInstance.showMessage({ message: error, type: 'error', useTimeout: false });
	}

	function displayRegistrationSuccess() {
		$('.register-content').fadeTo(animSpeed, 0, easing, function() {
			$('.register-content').html(tmpl("template-registration-success")).fadeTo(animSpeed, 1, easing, function() {
				$('.register-graphic-envelope').addClass('register-graphics-scaling');
				$('.register-graphic-circle').addClass('register-graphics-scaling');
			});
			$('.register-graphic-envelope').addClass('register-graphics-scale');
			$('.register-graphic-circle').addClass('register-graphics-scale');
		});
	}

	function registerSubmitHandler(form) {
		const submitButton = Ladda.create($(form).find('button[type="submit"]').get(0));
		submitButton.start();
		NotificationInstance.clearTimer();
		$.ajax({
			type: $(form).attr('method'),
			url: $(form).attr('action'),
			data: $(form).serialize(),
			dataType: 'json'
		})
		.done(function(response) {
			submitButton.stop();
			const { success, message, errors, country, email } = response;
			if (success && message) { // Success
				NotificationInstance.showMessage({ message, type: 'successful', useTimeout: false });
				displayRegistrationSuccess();
				// Push registration event to Google Tag Manager
				dataLayer.push({
					event: 'registration',
					country,
					email
				});
			} else if (errors) {
				const { general, fields } = errors		
				if (fields && fields.length) { // Field-specific errors
					const fieldErrors = fields.map(({ error }) => error).join('<br />');
					NotificationInstance.showMessage({
						message: `<strong>Please correct the following errors:</strong><br/>${fieldErrors}`,
						type: 'error',
						useTimeout: false
					});
				} else if (general) { // General error
					NotificationInstance.showMessage({
						message: general,
						type: 'error',
						useTimeout: false
					});
				} else { // Non-specific error
					handleRegistrationError('There was a server error.');
					return false;
				}
			} else { // Non-specific error
				handleRegistrationError('There was a server error.');
				return false;
			}
		}).fail(function() {
			submitButton.stop();
			handleRegistrationError('There was a server error.');
		});
		return false;
	}

	$(document).ready(function() {
		$("#registrationForm")
		.validate({
			errorElement: "div",
			rules: {
				password2: {
					equalTo: "#password"
				},
				email: {
					email: true
				},
				username: {
					username: true,
					minlength: 4,
					maxlength: 25,
					illegal: true
				},
				password: {
					minlength: 8,
					notequalTo: "#username"
				},
				phone: {
					phone: true
				}
			},
			messages: {
				firstName: {
					required: "Please enter your first name"
				},
					lastName: {
					required: "Please enter your last name"
				},
				email: {
					required: "Please enter your email"
				},
				country: {
					required: "Please enter your country"
				},
				phone: {
					required: "Please enter your phone number"
				},
				password2: {
					required: "Please confirm your password",
					equalTo: "Passwords don't match"
				},
				username: {
					required: "Please enter a username",
					minlength: "Usernames must be at least 4 characters",
					maxlength: "Usernames must not have more than 25 characters"
				},
				password: {
					required: "Please enter a password",
					notequalTo: "Password cannot match username"
				}
			},
			submitHandler: registerSubmitHandler
		});
	});
}(document, jQuery));